<template>
  <div class="footer">
    <div class="mainFooter">
      <b-container fluid>
        <b-row class="mt-5">
          <b-col
            lg="4"
            md="6"
            sm="12"
            order-lg="1"
            order-sm="2"
            class="oficinas text-right"
          >
            <div>
              <h1>
                <img
                  loading="lazy"
                  src="../assets/img/icons/office.png"
                >
                {{ $t('message.offices') }}
              </h1>
              <b-row align-h="end">
                <b-col
                  lg="4"
                  md="6"
                  sm="6"
                >
                  <ul class="officinas">
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/granada/"
                      >{{ $t('footer.Granada') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/malaga/"
                      >{{ $t('footer.Málaga') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/valladolid/"
                      >{{ $t('footer.Valladolid') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/larioja/"
                      >{{ $t('footer.La_Rioja') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/alicante/"
                      >{{ $t('footer.Alicante') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/coruna/"
                      >{{ $t('footer.Coruña') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/barcelona/"
                      >{{ $t('footer.Barcelona') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/lugones/"
                      >{{ $t('footer.Lugones_Asturias') }}</a>
                    </li>
                  </ul>
                </b-col>
                <b-col
                  lg="4"
                  md="6"
                  sm="6"
                >
                  <ul class="officinas">
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/tenerife/"
                      >{{ $t('footer.Tenerife') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicadbilbao.com/"
                      >{{ $t('footer.Bilbao') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/castellon/"
                      >{{ $t('footer.Castellón') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="http://www.aicad-madrid.es/"
                      >{{ $t('footer.Juan_Bravo') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="http://www.aicad.do/"
                      >{{ $t('footer.Dominicana') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/cuenca/"
                      >{{ $t('footer.Cuenca') }}</a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.aicad.es/madrid/"
                      >{{ $t('footer.Madrid') }}</a>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col
            lg="4"
            order-lg="2"
            order-md="3"
            order-sm="3"
            class="noSmallCall"
          >
            <div style="height: 100px" />
          </b-col>
          <b-col
            lg="4"
            md="6"
            order-lg="3"
            order-md="2"
            order-sm="1"
            class="contacts"
          >
            <div
              id="contactCol"
              class="footerCols"
              style="margin-right: 0px;"
            >
              <div>
                <a
                  target="_blank"
                  href="https://twitter.com/abusinessschool"
                >
                  <font-awesome-icon
                    :icon="['fab', 'twitter']"
                    class="socialIcon"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://www.facebook.com/AICADBUSINESSSCHOOL/"
                >
                  <font-awesome-icon
                    :icon="['fab', 'facebook']"
                    class="socialIcon"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://es.linkedin.com/school/aicad-business-school/"
                >
                  <font-awesome-icon
                    :icon="['fab', 'linkedin']"
                    class="socialIcon"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://www.youtube.com/channel/UC1AZ0pvMZUCl6ete8j6KTZw"
                >
                  <font-awesome-icon
                    :icon="['fab', 'youtube']"
                    class="socialIcon"
                  />
                </a>
              </div>
              <div class="phoneDiv">
                <a
                  :href="'tel:' + $t('+17187172184')"
                  class="footerNumber"
                >{{ $t('+17187172184') }}</a>
                <span>{{ $t('USA') }}</span>
              </div>
              <div class="phoneDiv">
                <a
                  :href="'tel:' + $t('footer.tel_f')"
                  class="footerNumber"
                >{{ $t('footer.tel_f') }}</a>
                <span>{{ $t('footer.REPÚBLICA_DOMINICANA') }}</span>
              </div>
              <div class="phoneDiv">
                <a
                  :href="'tel:' + $t('footer.tel2')"
                  class="footerNumber"
                >{{ $t('footer.tel2') }}</a>
                <span>{{ $t('footer.GUATEMALA') }}</span>
              </div>
              <div class="phoneDiv">
                <a
                  :href="'tel:' + $t('footer.tel3')"
                  class="footerNumber"
                >{{ $t('footer.tel3') }}</a>
                <span>{{ $t('footer.ECUADOR') }}</span>
              </div>
              <div class="phoneDiv">
                <a
                  :href="'tel:' + $t('footer.tel4')"
                  class="footerNumber"
                >{{ $t('footer.tel4') }}</a>
                <span>{{ $t('footer.COSTA_RICA') }}</span>
              </div>
              <div class="phoneDiv">
                <a
                  :href="'tel:' + $t('footer.tel5')"
                  class="footerNumber"
                >{{ $t('footer.tel5') }}</a>
                <span>{{ $t('footer.ITALIA') }}</span>
              </div>
              <div class="phoneDiv">
                <a
                  :href="'tel:' + $t('footer.tel6')"
                  class="footerNumber"
                >{{ $t('footer.tel6') }}</a>
                <span>{{ $t('footer.ALEMANIA') }}</span>
              </div>
              <div class="btnEnviar formPie">
                <b-link href="https://www.aicad.info/contacta-con-nosotros">
                  {{ $t('message.contact') }}
                  <font-awesome-icon
                    :icon="['fas', 'phone']"
                    style="float: right;"
                  />
                </b-link>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <svg
      class="kampas"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      style="background-color: #f3f3f3;margin-bottom:20px; height: 100px;width: 100%;transform: scale(1, -1);"
    >
      <polygon
        fill="#f9f9f9"
        points="0,100 100,0 0,0"
      />
    </svg>
    <a
      v-smooth-scroll="{ duration: 1000 }"
      class="angleUp"
      href="#app"
    >
      <font-awesome-icon
        class="doubleUpIcon"
        :icon="['fas', 'angle-double-up']"
      />
    </a>
    <div
      class="subFooter"
      style="background-color: #f9f9f9; margin-top: -20px;"
    >
      <div
        class="beforeFooterEnd"
        style="margin-bottom: 30px;"
      >
        <div style="width:60%; margin:auto;">
          <div class="twoCols">
            <div class="title-effect">
              <span
                class="mt-1 first"
                style="display: block;text-transform: uppercase;color: #333; font-size:36px;line-height: 25px;"
              >{{
                $t('footer.Get')
              }}</span>
              <div
                class="rw-words rw-words-1"
                style="letter-spacing: normal;color: #333;text-transform: uppercase;font-weight: 700;line-height: 44px;font-size:48px;display: inline;"
              >
                <span style="position: absolute; animation-delay: 0s">{{ $t('footer.more') }}</span>
                <span style="position: absolute; animation-delay: 2s">{{ $t('footer.the_best') }}</span>
                <span style="position: absolute; animation-delay: 4s">{{ $t('footer.the_best') }}</span>
              </div>
              <hr style="margin-top: 25px;visibility: hidden;margin-bottom: 0px;">
              <span
                class="title-effect-sub"
                style="line-height: 2.4em;font-size: 22px;text-transform: lowercase;color: #666;font-weight: 400;white-space: nowrap;"
              >{{ $t('footer.of_human_talent') }}</span>
            </div>
          </div>
          <div
            class="twoCols"
            style="text-align: right;"
          >
            <img
              loading="lazy"
              src="../assets/img/footLogos.png"
            >
          </div>
        </div>
      </div>
      <div class="footerEnd">
        <div style="width: 60%;margin: auto;display:flex;flex-wrap:wrap;">
          <a
            target="_blank"
            href="https://www.aicad.es/aviso-legal-privacidad/"
          >{{ $t('message.privacy_policy') }}</a>
          <a
            target="_blank"
            href="https://www.aicad.es/delegaciones/"
          >{{ $t('message.delegations') }}</a>
          <a
            target="_blank"
            href="https://www.aicad.es/condiciones-de-contratacion/"
          >{{ $t('message.general_conditions') }}</a>
          <a
            target="_blank"
            href="https://www.aicad.es/politica-de-cookies/"
          >{{ $t('message.cookies_policy') }}</a>
          <a
            target="_blank"
            href="https://www.aicad.es/preguntas-frecuentes/"
          >{{ $t('message.FAQ') }}</a>
          <a style="width:50px" />
        </div>
      </div>
    </div>
    <AcceptCookies />
  </div>
</template>

<script>
import AcceptCookies from '@/components/AcceptCookies';
export default {
    components: {
        AcceptCookies,
    },
};
</script>

<style scoped>
.footer {
	margin-top: 120px;
}

.footerEnd {
	line-height: 60px;
	background: #f2f2f2;
	text-align: center;
}
.footerEnd a {
	color: #666;
	font-size: 13px;
	padding: 0 15px 0 0;
}

.subFooter .twoCols {
	display: inline-block;
	width: 49%;
}

.beforeFooterEnd .title-effect .rw-words-1 span {
	animation-name: rotateWordsFirst;
	animation-duration: 6s;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	animation-delay: 0s;
	opacity: 0;
	margin-left: -4px;
}

/* Change words in botoom footer influence message */
@keyframes rotateWordsFirst {
	0% {
		opacity: 0;
		animation-timing-function: linear;
		height: 0;
	}
	8% {
		opacity: 1;
		/* height: 60px; */
	}
	19% {
		opacity: 1;
		/* height: 60px; */
	}
	40% {
		opacity: 0;
		/* height: 60px; */
	}
	100% {
		opacity: 0;
	}
}

.title-effect {
	text-align: left;
}

@media screen and (max-width: 767px) {
	.twoCols img {
		visibility: hidden;
	}
}

.mainFooter {
	margin-top: -120px;
	background: #f3f3f3 url('http://aicad.do/images/footerImage.png') no-repeat;
	background-size: contain;
	background-position: center;
}

.socialIcon {
	width: 45px;
	height: 45px;
	border-radius: 50%;
	padding: 12px;
	border: 2px solid black;
	color: black;
}

.footerCols a {
	margin-right: 5px;
	line-height: 7px;
}

.footerNumber {
	display: block;
	font-size: 1.1rem;
	font-weight: 700;
	color: black;
	letter-spacing: 1px;
	margin-top: 15px;
}

.phoneDiv {
	margin-bottom: 15px;
}

.footerCols span {
	color: black;
	font-size: 12px;
	letter-spacing: 1px;
}

.footThreeCols {
	display: inline-block;
	margin-top: 30px;
	text-align: right;
}

ul.officinas {
	list-style: none;
}

.officinas a {
	color: black;
	font-size: 15px;
}

.angleUp {
	position: relative;
	float: right;
	margin-right: 18%;
	margin-top: -60px;
}

.angleUp .socialIcon {
	color: white;
	border-color: white;
	background: black;
}

.btnEnviar a {
	border: 3px solid black;
	float: left;
	width: 100%;
	padding: 11px 10px;
	text-align: left;
	color: black !important;
	text-decoration: none;
}

.btnEnviar {
	width: 45%;
	color: black !important;
	font-size: 16px;
	background: transparent;
	float: left;
	font-weight: 700 !important;
}

.formPie {
	width: 40%;
	margin-top: 10px;
	margin-right: 12px;
}

@media screen and (max-width: 991px) {
	.noSmallCall {
		display: none;
	}

	.mainFooter {
		background: #f3f3f3;
	}
}

@media screen and (max-width: 500px) {
	.oficinas {
		display: none;
	}

	.contacts {
		text-align: center !important;
	}

	.formPie {
		width: 50%;
		margin-right: auto;
		margin-left: auto;
	}

	.formPie a {
		text-align: center;
	}
}

.oficinas h1 {
	font-weight: 300;
	font-size: 2em !important;
	margin: 10px;
	color: #232323;
	font-family: 'open sans condensed', Arial, sans-serif !important;
	text-transform: uppercase;
	letter-spacing: -2px;
}

svg.socialIcon:hover {
	border-color: #333;
	transition: 0.3s ease;
}
svg.socialIcon {
	transition: 0.3s ease;
}

svg.socialIcon.svg-inline--fa.fa-youtube.fa-w-18:hover {
	color: red;
}

svg.socialIcon.svg-inline--fa.fa-facebook.fa-w-14:hover {
	color: #3c5a99;
}

svg.socialIcon.svg-inline--fa.fa-twitter.fa-w-16:hover {
	color: #1bb2e9;
}

svg.socialIcon.svg-inline--fa.fa-linkedin.fa-w-14:hover {
	color: #006699;
}

a.footerNumber {
	text-decoration: none;
	transition: 0.3s ease;
}

a.footerNumber:hover {
	opacity: 0.6;
	transition: 0.3s ease;
}

.btnEnviar a:hover {
	transform: scale(1.05);
	transition: 0.3s ease;
	color: black !important;
}

.btnEnviar a {
	transition: 0.3s ease;
}

.doubleUpIcon {
	border-radius: 50%;
	padding: 12px;
	width: 40px;
	height: 40px;
	color: white;
	background: black;
}

svg.doubleUpIcon:hover {
	opacity: 0.8;
	transition: 0.3s ease;
}

svg.doubleUpIcon {
	transition: 0.3s ease;
}

.officinas a:hover {
	opacity: 0.8;
	transition: 0.3s ease;
}

.officinas a {
	transition: 0.3s ease;
}

@media screen and (max-width: 1219px) {
	.formPie {
		width: 40%;
	}
}
</style>
